export const scrollFrameAspectRatio = 2.39
export const scrollFrameUrls = [
  '/frames-clean/frame_000_delay-0.041s.jpg',
  '/frames-clean/frame_001_delay-0.041s.jpg',
  '/frames-clean/frame_002_delay-0.041s.jpg',
  '/frames-clean/frame_003_delay-0.041s.jpg',
  '/frames-clean/frame_004_delay-0.041s.jpg',
  '/frames-clean/frame_005_delay-0.041s.jpg',
  '/frames-clean/frame_006_delay-0.041s.jpg',
  '/frames-clean/frame_007_delay-0.041s.jpg',
  '/frames-clean/frame_008_delay-0.041s.jpg',
  '/frames-clean/frame_009_delay-0.041s.jpg',
  '/frames-clean/frame_010_delay-0.041s.jpg',
  '/frames-clean/frame_011_delay-0.041s.jpg',
  '/frames-clean/frame_012_delay-0.041s.jpg',
  '/frames-clean/frame_013_delay-0.041s.jpg',
  '/frames-clean/frame_014_delay-0.041s.jpg',
  '/frames-clean/frame_015_delay-0.041s.jpg',
  '/frames-clean/frame_016_delay-0.041s.jpg',
  '/frames-clean/frame_017_delay-0.041s.jpg',
  '/frames-clean/frame_018_delay-0.041s.jpg',
  '/frames-clean/frame_019_delay-0.041s.jpg',
  '/frames-clean/frame_020_delay-0.041s.jpg',
  '/frames-clean/frame_021_delay-0.041s.jpg',
  '/frames-clean/frame_022_delay-0.041s.jpg',
  '/frames-clean/frame_023_delay-0.041s.jpg',
  '/frames-clean/frame_024_delay-0.041s.jpg',
  '/frames-clean/frame_025_delay-0.041s.jpg',
  '/frames-clean/frame_026_delay-0.041s.jpg',
  '/frames-clean/frame_027_delay-0.041s.jpg',
  '/frames-clean/frame_028_delay-0.041s.jpg',
  '/frames-clean/frame_029_delay-0.041s.jpg',
  '/frames-clean/frame_030_delay-0.041s.jpg',
  '/frames-clean/frame_031_delay-0.041s.jpg',
  '/frames-clean/frame_032_delay-0.041s.jpg',
  '/frames-clean/frame_033_delay-0.041s.jpg',
  '/frames-clean/frame_034_delay-0.041s.jpg',
  '/frames-clean/frame_035_delay-0.041s.jpg',
  '/frames-clean/frame_036_delay-0.041s.jpg',
  '/frames-clean/frame_037_delay-0.041s.jpg',
  '/frames-clean/frame_038_delay-0.041s.jpg',
  '/frames-clean/frame_039_delay-0.041s.jpg',
  '/frames-clean/frame_040_delay-0.041s.jpg',
  '/frames-clean/frame_041_delay-0.041s.jpg',
  '/frames-clean/frame_042_delay-0.041s.jpg',
  '/frames-clean/frame_043_delay-0.041s.jpg',
  '/frames-clean/frame_044_delay-0.041s.jpg',
  '/frames-clean/frame_045_delay-0.041s.jpg',
  '/frames-clean/frame_046_delay-0.041s.jpg',
  '/frames-clean/frame_047_delay-0.041s.jpg',
  '/frames-clean/frame_048_delay-0.041s.jpg',
  '/frames-clean/frame_049_delay-0.041s.jpg',
  '/frames-clean/frame_050_delay-0.041s.jpg',
  '/frames-clean/frame_051_delay-0.041s.jpg',
  '/frames-clean/frame_052_delay-0.041s.jpg',
  '/frames-clean/frame_053_delay-0.041s.jpg',
  '/frames-clean/frame_054_delay-0.041s.jpg',
  '/frames-clean/frame_055_delay-0.041s.jpg',
  '/frames-clean/frame_056_delay-0.041s.jpg',
  '/frames-clean/frame_057_delay-0.041s.jpg',
  '/frames-clean/frame_058_delay-0.041s.jpg',
  '/frames-clean/frame_059_delay-0.041s.jpg',
  '/frames-clean/frame_060_delay-0.041s.jpg',
  '/frames-clean/frame_061_delay-0.041s.jpg',
  '/frames-clean/frame_062_delay-0.041s.jpg',
  '/frames-clean/frame_063_delay-0.041s.jpg',
  '/frames-clean/frame_064_delay-0.041s.jpg',
  '/frames-clean/frame_065_delay-0.041s.jpg',
  '/frames-clean/frame_066_delay-0.041s.jpg',
  '/frames-clean/frame_067_delay-0.041s.jpg',
  '/frames-clean/frame_068_delay-0.041s.jpg',
  '/frames-clean/frame_069_delay-0.041s.jpg',
  '/frames-clean/frame_070_delay-0.041s.jpg',
  '/frames-clean/frame_071_delay-0.041s.jpg',
  '/frames-clean/frame_072_delay-0.041s.jpg',
  '/frames-clean/frame_073_delay-0.041s.jpg',
  '/frames-clean/frame_074_delay-0.041s.jpg',
  '/frames-clean/frame_075_delay-0.041s.jpg',
  '/frames-clean/frame_076_delay-0.041s.jpg',
  '/frames-clean/frame_077_delay-0.041s.jpg',
  '/frames-clean/frame_078_delay-0.041s.jpg',
  '/frames-clean/frame_079_delay-0.041s.jpg',
  '/frames-clean/frame_080_delay-0.041s.jpg',
  '/frames-clean/frame_081_delay-0.041s.jpg',
  '/frames-clean/frame_082_delay-0.041s.jpg',
  '/frames-clean/frame_083_delay-0.041s.jpg',
  '/frames-clean/frame_084_delay-0.041s.jpg',
  '/frames-clean/frame_085_delay-0.041s.jpg',
  '/frames-clean/frame_086_delay-0.041s.jpg',
  '/frames-clean/frame_087_delay-0.041s.jpg',
  '/frames-clean/frame_088_delay-0.041s.jpg',
  '/frames-clean/frame_089_delay-0.041s.jpg',
  '/frames-clean/frame_090_delay-0.041s.jpg',
  '/frames-clean/frame_091_delay-0.041s.jpg',
  '/frames-clean/frame_092_delay-0.041s.jpg',
  '/frames-clean/frame_093_delay-0.041s.jpg',
  '/frames-clean/frame_094_delay-0.041s.jpg',
  '/frames-clean/frame_095_delay-0.041s.jpg',
  '/frames-clean/frame_096_delay-0.041s.jpg',
  '/frames-clean/frame_097_delay-0.041s.jpg',
  '/frames-clean/frame_098_delay-0.041s.jpg',
  '/frames-clean/frame_099_delay-0.041s.jpg',
  '/frames-clean/frame_100_delay-0.041s.jpg',
  '/frames-clean/frame_101_delay-0.041s.jpg',
  '/frames-clean/frame_102_delay-0.041s.jpg',
  '/frames-clean/frame_103_delay-0.041s.jpg',
  '/frames-clean/frame_104_delay-0.041s.jpg',
  '/frames-clean/frame_105_delay-0.041s.jpg',
  '/frames-clean/frame_106_delay-0.041s.jpg',
  '/frames-clean/frame_107_delay-0.041s.jpg',
  '/frames-clean/frame_108_delay-0.041s.jpg',
  '/frames-clean/frame_109_delay-0.041s.jpg',
  '/frames-clean/frame_110_delay-0.041s.jpg',
  '/frames-clean/frame_111_delay-0.041s.jpg',
  '/frames-clean/frame_112_delay-0.041s.jpg',
  '/frames-clean/frame_113_delay-0.041s.jpg',
  '/frames-clean/frame_114_delay-0.041s.jpg',
  '/frames-clean/frame_115_delay-0.041s.jpg',
  '/frames-clean/frame_116_delay-0.041s.jpg',
  '/frames-clean/frame_117_delay-0.041s.jpg',
  '/frames-clean/frame_118_delay-0.041s.jpg',
  '/frames-clean/frame_119_delay-0.041s.jpg',
  '/frames-clean/frame_120_delay-0.041s.jpg',
  '/frames-clean/frame_121_delay-0.041s.jpg',
  '/frames-clean/frame_122_delay-0.041s.jpg',
  '/frames-clean/frame_123_delay-0.041s.jpg',
  '/frames-clean/frame_124_delay-0.041s.jpg',
  '/frames-clean/frame_125_delay-0.041s.jpg',
  '/frames-clean/frame_126_delay-0.041s.jpg',
  '/frames-clean/frame_127_delay-0.041s.jpg',
  '/frames-clean/frame_128_delay-0.041s.jpg',
  '/frames-clean/frame_129_delay-0.041s.jpg',
  '/frames-clean/frame_130_delay-0.041s.jpg',
  '/frames-clean/frame_131_delay-0.041s.jpg',
  '/frames-clean/frame_132_delay-0.041s.jpg',
  '/frames-clean/frame_133_delay-0.041s.jpg',
  '/frames-clean/frame_134_delay-0.041s.jpg',
  '/frames-clean/frame_135_delay-0.041s.jpg',
  '/frames-clean/frame_136_delay-0.041s.jpg',
  '/frames-clean/frame_137_delay-0.041s.jpg',
  '/frames-clean/frame_138_delay-0.041s.jpg',
  '/frames-clean/frame_139_delay-0.041s.jpg',
  '/frames-clean/frame_140_delay-0.041s.jpg',
  '/frames-clean/frame_141_delay-0.041s.jpg',
  '/frames-clean/frame_142_delay-0.041s.jpg',
  '/frames-clean/frame_143_delay-0.041s.jpg',
  '/frames-clean/frame_144_delay-0.041s.jpg',
  '/frames-clean/frame_145_delay-0.041s.jpg',
  '/frames-clean/frame_146_delay-0.041s.jpg',
  '/frames-clean/frame_147_delay-0.041s.jpg',
  '/frames-clean/frame_148_delay-0.041s.jpg',
  '/frames-clean/frame_149_delay-0.041s.jpg',
  '/frames-clean/frame_150_delay-0.041s.jpg',
  '/frames-clean/frame_151_delay-0.041s.jpg',
  '/frames-clean/frame_152_delay-0.041s.jpg',
  '/frames-clean/frame_153_delay-0.041s.jpg',
  '/frames-clean/frame_154_delay-0.041s.jpg',
  '/frames-clean/frame_155_delay-0.041s.jpg',
  '/frames-clean/frame_156_delay-0.041s.jpg',
  '/frames-clean/frame_157_delay-0.041s.jpg',
  '/frames-clean/frame_158_delay-0.041s.jpg',
  '/frames-clean/frame_159_delay-0.041s.jpg',
  '/frames-clean/frame_160_delay-0.041s.jpg',
  '/frames-clean/frame_161_delay-0.041s.jpg',
  '/frames-clean/frame_162_delay-0.041s.jpg',
  '/frames-clean/frame_163_delay-0.041s.jpg',
  '/frames-clean/frame_164_delay-0.041s.jpg',
  '/frames-clean/frame_165_delay-0.041s.jpg',
  '/frames-clean/frame_166_delay-0.041s.jpg',
  '/frames-clean/frame_167_delay-0.041s.jpg',
  '/frames-clean/frame_168_delay-0.041s.jpg',
  '/frames-clean/frame_169_delay-0.041s.jpg',
  '/frames-clean/frame_170_delay-0.041s.jpg',
  '/frames-clean/frame_171_delay-0.041s.jpg',
  '/frames-clean/frame_172_delay-0.041s.jpg',
  '/frames-clean/frame_173_delay-0.041s.jpg',
  '/frames-clean/frame_174_delay-0.041s.jpg',
  '/frames-clean/frame_175_delay-0.041s.jpg',
  '/frames-clean/frame_176_delay-0.041s.jpg',
  '/frames-clean/frame_177_delay-0.041s.jpg',
  '/frames-clean/frame_178_delay-0.041s.jpg',
  '/frames-clean/frame_179_delay-0.041s.jpg',
  '/frames-clean/frame_180_delay-0.041s.jpg',
  '/frames-clean/frame_181_delay-0.041s.jpg',
  '/frames-clean/frame_182_delay-0.041s.jpg',
  '/frames-clean/frame_183_delay-0.041s.jpg',
  '/frames-clean/frame_184_delay-0.041s.jpg',
  '/frames-clean/frame_185_delay-0.041s.jpg',
  '/frames-clean/frame_186_delay-0.041s.jpg',
  '/frames-clean/frame_187_delay-0.041s.jpg',
  '/frames-clean/frame_188_delay-0.041s.jpg',
  '/frames-clean/frame_189_delay-0.041s.jpg',
  '/frames-clean/frame_190_delay-0.041s.jpg',
  '/frames-clean/frame_191_delay-0.041s.jpg',
]
export const scrollFrameCount = scrollFrameUrls.length
